module.exports = __webpack_public_path__ + "img/mark_h.e9c23170.png";